var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{attrs:{"view":"hHh lpR fFf"}},[_c('app-header',{ref:"header",attrs:{"brand-logo":_vm.$config.branding.header.logo,"brand-text":_vm.$config.branding.header.text}}),_c('q-page-container',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }